import React, { useEffect, useState } from 'react'
import { Select, SelectProps } from '@node-space/storybook-components/dist/Select'
import ErrorText from './components/ErrorText'
import ExpiryOption from './components/ExpiryOption'
import ExpiryValue from './components/ExpiryValue'
import InputLabel from './components/InputLabel'
import { getExpirySelectStyles } from './ExpirySelectStyles'

interface ExpirySelectProps extends SelectProps {
  inputValue?: number
  onValueChange?: Function
}

interface ExpiryIntervalInterface {
  expiryAmount: number
  expiryType: string
}

const expiryAmountConvertor: { [index: string]: number } = {
  days: 1 / (60 * 24),
  minutes: 60 * 24,
}

export const ExpirySelect = React.forwardRef(
  ({ inputValue, ...selectProps }: ExpirySelectProps, ref: React.MutableRefObject<null>) => {
    const [expiryInterval, setExpiryInterval] = useState<ExpiryIntervalInterface>({
      expiryAmount: inputValue ?? 2,
      expiryType: selectProps.value ? selectProps.value : 'days',
    })

    useEffect(() => {
      if (selectProps.onValueChange) {
        selectProps.onValueChange(expiryInterval)
      }
    }, [expiryInterval])

    const extendedStyles = getExpirySelectStyles()

    return (
      <div className="-mt-0.5">
        <InputLabel>Expiry Date</InputLabel>
        <div className="expiry-container p-0 border-box flex rounded bg-neutral-cotton border border-1 h-10 border-[#BABEC1] focus-within:border-primary-500 hover:border-primary-500 focus:border-primary-500 box-border">
          <div className="z-10 flex-auto">
            <input
              ref={ref}
              inputMode="numeric"
              className="ml-1 h-9 w-full pl-3 text-sm font-normal text-gray-10 focus:outline-none focus-visible:outline-none focus-visible:outline-none"
              name="expiryAmount"
              onChange={e =>
                setExpiryInterval({
                  ...expiryInterval,
                  [e.target.name]: e.target.value,
                })
              }
              value={expiryInterval.expiryAmount}
            />
          </div>
          <div className="flex flex-shrink-0 pl-2 text-sm font-normal">
            <span className="z-10 my-2 inline-block w-px bg-gray-03"></span>
            <Select
              borderless={true}
              withIndicator={false}
              matchContent={true}
              {...selectProps}
              error={false}
              errorText={''}
              Option={ExpiryOption}
              ValueContainer={ExpiryValue}
              name="expiryType"
              value={expiryInterval.expiryType}
              onChange={value => {
                const expiryTime =
                  Number(expiryInterval.expiryAmount) * expiryAmountConvertor[value]

                if (value != expiryInterval.expiryType) {
                  setExpiryInterval({
                    ...expiryInterval,
                    expiryAmount: expiryTime,
                    expiryType: value,
                  })
                }
              }}
              extendStyles={extendedStyles}
            />
          </div>
        </div>
        {selectProps.error && selectProps.errorText && <ErrorText text={selectProps.errorText} />}
      </div>
    )
  }
)
